export function validateEmail(text: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(text);
}

export function isLinkedInUrlValid(linkedInUrl: string): boolean {
  const trimmedUrl = linkedInUrl.trim();
  if (!trimmedUrl) return false;
  return /^(https?:\/\/)?(www\.)?linkedin\.com\/in\//.test(trimmedUrl);
}